var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	22495: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	25517: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	86764: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(43160))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ant-design/icons",
	},
	2752: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(495), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(25554))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",
	},
	35869: {
		fallback: () => (() => (__webpack_require__(87069))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.13.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "axios",
	},
	74557: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(55214))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.9.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"495": [
		22495
	],
	"728": [
		2752,
		35869,
		74557
	],
	"764": [
		86764
	],
	"898": [
		25517
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}